interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ message = "Connection lost", onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="font-mono text-xs font-semibold uppercase tracking-[0.12em] text-status-error">
        Signal Lost
      </div>
      <p className="mt-2 text-sm text-muted">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 rounded-md border border-line bg-surface px-3 py-1.5 font-mono text-xs font-medium text-ink transition-colors hover:bg-code-bg"
          type="button"
        >
          Retry
        </button>
      )}
    </div>
  );
}
